/**
 * description 多媒体资源左侧
 * created by he.zhikai
 * created on 217-12-19
 */
"use strict";
angular.module('multiMediaResourceLeftModule', []).
directive("multiMediaResourceLeft", ["$state", "$timeout", "resourceCenterService", function($state, $timeout, resourceCenterService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            selectedParent: '='
        },
        templateUrl: './resourceCenter/multiMediaResource/left/left_tpl.html',
        link: function(scope, $elem, $attrs) {

        }
    };
}]);